import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import ErrorBoundary from "./ErrorBoundary";
import "./index.css";

import thunkMiddleware from "redux-thunk";
import { createStore, applyMiddleware } from "redux";

import { Provider } from "react-redux";
import reducer from "./reducers";

let store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // for redux devTools to function
  applyMiddleware(thunkMiddleware)
);

// Set-up the third party React middleware libraries: Redux and Thunk
ReactDOM.render(
  // Create the Redux "store"
  <Provider store={store}>
    {/* <ErrorBoundary> */}
      <App />
    {/* </ErrorBoundary> */}
  </Provider>,
  document.getElementById("root")
);
